import { MODE_TRANSFER } from '@/lib/constants';
import { TimelineSegment } from '@/lib/models/timeline-item/types';
import { tv } from '@/utils/styles';

import { getDaysBetween } from '../utils';

export interface TimelineBarSegmentProps {
  segment: TimelineSegment;
  gridSize: number;
}

const TimelineBarSegment = ({ segment, gridSize }: TimelineBarSegmentProps) => {
  const { fromDate, toDate, mode } = segment;
  const isTransfer = mode === MODE_TRANSFER;
  const days = getDaysBetween(fromDate, toDate, false);

  const { base } = styles();

  return <div className={base({ isTransfer })} style={{ width: `${days * gridSize}px` }} />;
};

const styles = tv({
  slots: {
    base: 'relative h-8',
  },
  variants: {
    isTransfer: {
      true: 'z-6 first:rounded-l-lg last:rounded-r-lg',
      false: 'z-7 rounded-lg border border-grey-350 bg-white shadow-soft hover:border-grey-400 hover:shadow-md',
    },
  },
});

export { TimelineBarSegment };
